module.exports = __webpack_public_path__ + "static/feature1-123b955e86c25250e3b4d7029a365f77.mp4";